"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgHomeTenant24 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", role: "img" }, props, { children: (0, jsx_runtime_1.jsxs)("g", __assign({ fill: "none", fillRule: "evenodd" }, { children: [(0, jsx_runtime_1.jsx)("path", { fill: "none", d: "M0 0h24v24H0z" }), (0, jsx_runtime_1.jsx)("path", { d: "M12.15 12.488a1.95 1.95 0 1 0 0-3.9 1.95 1.95 0 0 0 0 3.9Zm2.6 4.2v-1.293a.867.867 0 0 0-.426-.747c-.422-.25-1.152-.56-2.174-.56-1.035 0-1.76.31-2.177.558a.866.866 0 0 0-.422.745v1.297h5.198ZM18 8.78v9.808H6V8.78m-1.616.984L12 5.412l7.616 4.352", stroke: "currentColor" })] })) }))); };
exports.default = SvgHomeTenant24;
